module.exports = __webpack_public_path__ + "static/media/promo-card-home-card.048de649.png";